import { render } from "./CadastrarPropaganda.vue?vue&type=template&id=b32d5ac6&scoped=true"
import script from "./CadastrarPropaganda.vue?vue&type=script&lang=js"
export * from "./CadastrarPropaganda.vue?vue&type=script&lang=js"

import "./CadastrarPropaganda.vue?vue&type=style&index=0&id=b32d5ac6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32d5ac6"]])

export default __exports__